import { SvgIconProps } from '@material-ui/core';
import React from 'react';

const ArrowDownIcon = (props: SvgIconProps): JSX.Element => (
  <svg
    fill="none"
    height="17"
    viewBox="0 0 16 17"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.7628 4.24207H13.4235C13.3324 4.24207 13.2467 4.28671 13.1931 4.35992L8.11993 11.3528L3.04671 4.35992C2.99314 4.28671 2.90742 4.24207 2.81635 4.24207H1.47707C1.361 4.24207 1.29314 4.37421 1.361 4.46885L7.65743 13.1492C7.886 13.4635 8.35385 13.4635 8.58064 13.1492L14.8771 4.46885C14.9467 4.37421 14.8789 4.24207 14.7628 4.24207Z"
      fill="#333333"
    />
  </svg>
);

export default ArrowDownIcon;
